// ** React Imports
import React from "react";

// ** MUI Imports
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
  Icon,
  Typography,
} from "@mui/material";

// ** Third Party Imports
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  orders: string[];
  handleClose: () => void;
  handleDelete: () => void;
}

const DeleteOrderDialog = (props: Props) => {
  // ** Props
  const { open, orders, handleClose, handleDelete } = props;

  // ** Hooks
  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      scroll="body"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        {t("Delete order")}
        <IconButton
          size="small"
          onClick={handleClose}
          sx={{ position: "absolute", right: "1rem", top: "1rem" }}
        >
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography textAlign="center">
          {orders.length === 1
            ? t("Are you sure you want this delete order?")
            : t("Naozaj chcete tieto objednávky odstrániť?")}
        </Typography>
        <Typography textAlign="center" color="error" fontWeight={700}>
          {orders.join(", ")}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          size="large"
          type="submit"
          sx={{ mr: 2 }}
          variant="contained"
          onClick={handleDelete}
        >
          {t("Áno")}
        </Button>
        <Button
          size="large"
          color="secondary"
          variant="outlined"
          onClick={handleClose}
        >
          {t("Nie")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrderDialog;
